// extracted by mini-css-extract-plugin
var _1 = "EntityProfileFlatItem-moduleEntityProfileFlatItem__oxf3j ListItem-moduleListItem__NInUA";
var _2 = "EntityProfileFlatItem-moduletext__Hff6R";
export { _1 as "EntityProfileFlatItem", _2 as "text" }
